import React from "react";
import PhoneBundles from "@components/common/widgets/PhoneBundles";
import PromoSlider from "@components/common/widgets/PromoSlider";
import ScrollingAD from "@components/phone/ScrollingAD";
import PhoneCompare from "@components/phone/PhoneCompare";
import Roaming2 from "@components/common/widgets/Roaming2";
import Footer from "@components/common/footer/Footer";
import Navigation from "@components/common/Navigation/Navigation";
import FloatingActionButton from "@components/common/FloatingActionButton";

export default function PhoneApp() {
  return (
    <div className="row-height-100">
      <Navigation />
      <main>
        <PhoneBundles theme="purple" apiCallPath={"phone-bundles"} />
        <PromoSlider urlAPI="promoslider.phones" />
        <ScrollingAD apiCallPath={"phone-banners"} />
        <PhoneCompare />
        <Roaming2 urlAPI="phone-promo" />
      </main>
      <Footer />

      <FloatingActionButton/>
    </div>
  );
}
